import Handlebars from "handlebars";
import "#legacy/handlebars_helpers/background_color_helper.js";
import "#legacy/handlebars_helpers/strip_all_tags_helper.js";
import "#legacy/handlebars_helpers/parameterize_helper.js";

(function (global) {
  global.componentBackgroundOverlayTemplate = Handlebars.compile(
    '<div class="component-backdrop" style="background-color: {{background}}"></div>',
  );
  global.inPageNavigation = Handlebars.compile(
    '{{#if navigationTitle}}<sp-navigation-item class="anchor-bar-anchor" id="{{navigationIdentifier}}"></sp-navigation-item>{{/if}}',
  );

  function navigationEnabled(value) {
    // Keep string checkbox values aligned with ActiveModel::Type::Boolean.
    var stringFalseValues = ["0", "f", "F", "false", "FALSE", "off", "OFF"];
    return !!value && stringFalseValues.indexOf(value) === -1;
  }

  Handlebars.registerHelper("componentContentContainer", function (options) {
    this.background = Handlebars.helpers.backgroundColor(this.background_color);
    var backgroundElement = global.componentBackgroundOverlayTemplate(this);

    if (navigationEnabled(this.include_in_navigation)) {
      this.navigationTitle = Handlebars.helpers.stripAllTags(this.include_in_navigation_title || this.title);
      if (this.navigationTitle) {
        this.navigationIdentifier = Handlebars.helpers.parameterize(this.navigationTitle);
      }
    }

    var navigationElement = global.inPageNavigation(this);

    return new Handlebars.SafeString(
      '<div class="component-content-container">' + navigationElement + backgroundElement + options.fn(this) + "</div>",
    );
  });
})(typeof window !== "undefined" ? window : this);
